<template>
  <div class="background-image">
    <div class="content-wrap">
      <!-- 左侧轮播图区域 -->
      <div class="content-view" style="border-bottom-left-radius: 10px; border-top-left-radius: 10px;">
        <img src="../../../assets/image/new_slices/zhuanjia.jpg" alt="" style="width: 100%; height: 100%;">
      </div>
      <!-- 右侧登录区域 -->
      <div class="content-view">
        <div class="login-container">
          <!-- 返回首页链接 -->
          <div class="return-home">
            <a href="/todayEvaluation" class="return-link" @click.native="clearLoginCache">返回首页</a>
          </div>
          <!-- 标题 -->
          <div class="login-title">
            <div class="main-title">欢迎登录专家评标系统</div>
          </div>
          <!-- 登录表单 -->
          <div class="login-form">
            <!-- 身份证号输入 -->
            <div class="form-group">
              <div class="input-wrapper">
                <input type="text" placeholder="请输入身份证号" class="form-input" v-model="loginForm.password">
              </div>
            </div>
            <!-- 评标密码 -->
            <div class="form-group">
              <div class="input-wrapper">
                <input type="text" placeholder="请输入数字认证验证码" class="form-input" v-model="loginForm.pin">
              </div>
            </div>
            <!-- 登录按钮 -->
            <button class="login-btn" @click="handleLogin">登录</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { expertLogin, getAvoidInfo } from '@/api/modules/evaluation'
import Cookies from 'js-cookie'

export default {
  name: 'ExpertLogin',
  data() {
    return {
      // 登录表单
      loginForm: {
        name: '1',
        password: '',
        captcha: '',
        pin: ''
      }
    }
  },

  watch: {
    // 实时缓存登录表单
    loginForm: {
      deep: true,
      handler(val) {
        localStorage.setItem('expertLoginForm', JSON.stringify({
          name: val.name,
          password: val.password,
          pin: val.pin
        }))
      }
    }
  },
  mounted() {
    const registerCached = localStorage.getItem('registerExpertLoginCache')
    if (registerCached) {
      try {
        const parsed = JSON.parse(registerCached)
        this.loginForm.name = parsed.name || this.loginForm.name || ''
        this.loginForm.password = parsed.password || this.loginForm.password || ''
        this.loginForm.pin = parsed.pin || this.loginForm.pin || ''
      } catch (e) { /* ignore */ }
    }
    // 恢复缓存的登录表单
    const cached = localStorage.getItem('expertLoginForm')
    if (cached) {
      try {
        const parsed = JSON.parse(cached)
        this.loginForm.name = parsed.name || ''
        this.loginForm.password = parsed.password || ''
        this.loginForm.pin = parsed.pin || ''
      } catch (e) { /* ignore */ }
    }
    const token = Cookies.get('token')
    const evaluationId = Cookies.get('evaluationId')
    if (token && evaluationId) {
      this.$router.replace('/expertEvaluation')
    }
  },
  methods: {
    normalizeLoginForm() {
      const fields = ['name', 'password', 'pin']
      fields.forEach(field => {
        if (typeof this.loginForm[field] === 'string') {
          this.loginForm[field] = this.loginForm[field].trim()
        }
      })
    },

    handleLogin() {
      this.normalizeLoginForm()
      if (!this.loginForm.password) {
        this.$message.error('请输入身份证号')
        return
      }
      this.expertLogin()
    },
    expertLogin() {
      expertLogin({
        idCard: this.loginForm.password,
        loginName: this.loginForm.name,
        captchaCodeUuId: '',
        captchaCode: '',
        sectionCode: Cookies.get('bidSectionCode'),
        committeeId: Cookies.get('committeeId'),
        pin: this.loginForm.pin,
        pinEnsure: this.loginForm.pin
      }).then(res => {
        if (res.code === 200) {
          if (res.data.token) {
             Cookies.set('identity', res.data.identity)
            Cookies.set('token', res.data.token)
            Cookies.set('evaluationId', res.data.evaluationId)
            this.$router.replace('/expertEvaluation')
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log('登录失败:', err)
      })
    },
    clearLoginCache() {
      localStorage.clear()
      Cookies.remove('token')
      Cookies.remove('evaluationId')
      Cookies.remove('bidSectionCode')
      Cookies.remove('committeeId')
      Cookies.remove('projectName')
      Cookies.remove('projectCode')
    }
  }
}
</script>

<style lang="less" scoped>
.background-image {
  height: 100vh;
  background-image: url('../../../assets/image/new_slices/lgin_bg@2x.jpg');
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;

  .content-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    .content-view {
      width: 490px;
      height: 603px;
      background: #fff;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      position: relative;

      .carousel-element {
        height: 603px;

        :deep(.el-carousel__item) {
          height: 603px;
        }
      }

      .login-container {
        padding: 30px 40px;
        height: 100%;
        display: flex;
        flex-direction: column;

        .return-home {
          display: flex;
          text-align: right;
          justify-content: flex-end;
          align-items: center;

          .return-link {
            color: #666;
            text-decoration: none;
            font-size: 14px;
          }
        }

        .login-title {
          text-align: center;
          margin-bottom: 49px;
          margin-top: 35px;

          .main-title {
            font-size: 24px;
            font-weight: bold;
            color: #333;
            margin-bottom: 8px;
          }

        }

        .login-form {
          flex: 1;
          display: flex;
          flex-direction: column;

          .form-group {
            margin-bottom: 20px;

            .input-wrapper {
              display: flex;
              align-items: center;
              position: relative;



              .form-input {
                flex: 1;
                height: 45px;
                border: 1px solid #ddd;
                border-radius: 4px;
                padding: 0 15px;
                font-size: 14px;
                box-sizing: border-box;
                outline: none;
                transition: border-color 0.3s ease, box-shadow 0.3s ease;

                &:focus {
                  border-color: #409EFF;
                  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                }

                &::placeholder {
                  color: #999;
                }
              }
            }
          }

          .login-btn {
            width: 100%;
            height: 45px;
            background: #005EEC;
            color: white;
            border: none;
            border-radius: 4px;
            font-size: 16px;
            cursor: pointer;
            margin-top: 20px;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
              background: #66b1ff;
              transform: translateY(-1px);
              box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
            }
          }
        }
      }
    }
  }
}
</style>